/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { BonusPointsFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { BonusPointsFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const bonusPointsDataMock: BonusPointsFragmentFragment = {
  points: 12,
  type: 'PAYBACK',
};

export function getBonusPointsFragmentedData(data?: BonusPointsFragmentFragment) {
  return makeFragmentData(data || bonusPointsDataMock, BonusPointsFragmentFragmentDoc);
}
